import { useEffect, useState } from "react";

type Breakpoint = "mobile" | "tablet" | "desktop";

const MOBILE_MAX_WIDTH = 767;
const TABLET_MAX_WIDTH = 1023;

const getBreakpoint = (width: number): Breakpoint => {
  if (width <= MOBILE_MAX_WIDTH) {
    return "mobile";
  }

  if (width <= TABLET_MAX_WIDTH) {
    return "tablet";
  }

  return "desktop";
};

const getWindowWidth = () => {
  if (globalThis.window === undefined) {
    return TABLET_MAX_WIDTH + 1;
  }

  return globalThis.window.innerWidth;
};

export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState<Breakpoint>(() => getBreakpoint(getWindowWidth()));

  useEffect(() => {
    if (globalThis.window === undefined) {
      return undefined;
    }

    const updateBreakpoint = () => {
      setBreakpoint(getBreakpoint(globalThis.window.innerWidth));
    };

    updateBreakpoint();
    globalThis.window.addEventListener("resize", updateBreakpoint);

    return () => {
      globalThis.window.removeEventListener("resize", updateBreakpoint);
    };
  }, []);

  return breakpoint;
};
